import type { ReactNode } from 'react';
import { useContext } from 'react';

import { AgentAuthorityContext } from '@/lib/layout/AgentAuthorityContext';
import { ReadOnlyField } from '@/lib/pages/forms/components/ReadOnlyField';
import { formatMasked } from '@/lib/pages/forms/helpers';

export const AutoFilled = ({
  value,
  label,
  type = undefined,
  wideLabel,
  stretch = false,
  inputClass,
  readOnly,
  required = false,
  error = false,
}: {
  value: string | number | undefined | null;
  label?: ReactNode;
  wideLabel?: boolean;
  stretch?: boolean;
  type?: 'currency' | 'percentage';
  inputClass?: string;
  readOnly?: boolean;
  /** Renders the cosmetic `*` next to the label. Does not validate. */
  required?: boolean;
  /** Tints the label to flag a form-level error on a field the user can't edit. */
  error?: boolean;
}) => {
  const { editMode } = useContext(AgentAuthorityContext);

  if (!editMode || readOnly) {
    return (
      <ReadOnlyField
        label={label}
        value={value}
        mask={type}
        stretch={stretch}
        wideLabel={wideLabel}
      />
    );
  }

  return (
    <div className="flex items-center gap-4">
      {label ? (
        <p
          className={`${stretch ? `${wideLabel ? 'w-2/3' : 'w-1/3'}` : `${wideLabel ? 'w-2/5' : 'w-1/5'}`} text-sm font-semibold leading-5 ${error ? 'text-red-500' : ''}`}
        >
          {label}
          {required ? <span className="text-red-400">*</span> : null}
        </p>
      ) : (
        ''
      )}
      <div
        title={String(value) || undefined}
        className={`${stretch ? `${wideLabel ? 'w-1/3' : 'w-2/3'}` : `${wideLabel ? 'w-1/5' : 'w-2/5'}`} ${inputClass} h-10 overflow-hidden whitespace-nowrap rounded bg-brand-200 px-3 py-2 text-brand-500`}
      >
        {formatMasked(value, type)}
      </div>
    </div>
  );
};

export default AutoFilled;
